import { createApi } from '@reduxjs/toolkit/query/react';
import fetchBaseQuery from '../../../utils/fetchBaseQuery';
import servicesConfig from './services';
import endpointsBuilder from '../../../utils/endpointsBuilder';
import messageConfig from './messageConfig.json';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: fetchBaseQuery({ messageConfig }),
  endpoints: endpointsBuilder(servicesConfig),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  endpoints,
  // payment method
  useGetPaymentMethodTypesQuery,
  useCreateECheckAccountMutation,
  useCreateApplePayAccountMutation,
  useCreateGooglePayAccountMutation,
  useGetApplePaySessionMutation,
  // payment option
  useGetPaymentOptionsQuery,
  useLazyCalculatePPFQuery,
  // billing contact
  useVerifyAVSMutation,
} = paymentApi;
